<app-admin-header
    style="width: 100%"
    [header]="header"
    [links]="links"
    [breadcrumbs]="breadcrumbs"
    [stats]="[]"
></app-admin-header>
<section class="container-fluid ms-main-bg py-5" style="margin-top: -7rem">
    <div class="ms-pg-structure container m-top-8">
        <div class="white-box">
            <div class="row">
                <div
                    class="col-lg-2 col-md-6 col-6"
                    (click)="changeCurrentStatus(status.status)"
                    style="width: 20%; cursor: pointer"
                    *ngFor="let status of factorStatusConstants"
                >
                    <div
                        [ngClass]="currentStatus == status.status ? 'selected':''"
                        class="dashboard-black-box"
                    >
                        <div class="dashboard-flex-column">
                            <div>
                                <h4 class="dashboard-numbers">
                                    {{status.count}}
                                </h4>
                            </div>
                            <div>
                                <h4 class="dashboard-text">
                                    {{status.status | translator}}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-skelitions [hidden]="!skelition" [value]="2"></app-skelitions>
            <div class="row" *ngIf="!skelition">
                <div class="col-lg-12 col-md-6 col-12">
                    <div class="black-box">
                        <h4 class="dashboard-medium-h">
                            {{currentStatus | translator}}
                        </h4>
                        <div
                            class="w-100 d-flex align-items-center justify-content-between flex-row gap-2"
                        >
                            <div class="dashboard-purple-box">
                                {{'Factor' | translator}}
                            </div>
                            <div class="dashboard-purple-box">
                                {{'Channel' | translator}}
                            </div>
                            <div class="dashboard-purple-box">
                                {{'Measuring Type' | translator}}
                            </div>
                            <div
                                *ngIf="currentStatus != factorStatusConstants[0].status"
                                class="dashboard-purple-box"
                            >
                                {{'Repeat' | translator}}
                            </div>
                        </div>
                        <div
                            class="d-flex flex-column"
                            *ngFor="let factor of filteredData"
                        >
                            <div
                                class="w-100 d-flex align-items-center justify-content-between flex-row gap-2"
                            >
                                <div class="dashboard-white-box">
                                    {{factor.factor}}
                                </div>
                                <div
                                    class="dashboard-white-box"
                                    *ngIf="factor && factor.branchDetails && factor.branchDetails.name; else elseBlock"
                                >
                                    {{factor.channel.name}}
                                    ({{factor.branchDetails.name}} -
                                    <span
                                        *ngIf="factor.branchDetails.details.location.name"
                                        >{{factor.branchDetails.details.location.name}}</span
                                    >)
                                </div>
                                <ng-template #elseBlock>
                                    <div class="dashboard-white-box">
                                        {{factor.channel.name}}
                                    </div>
                                </ng-template>
                                <div class="dashboard-white-box">
                                    {{factor.measuringType}}
                                </div>
                                <div
                                    *ngIf="currentStatus != factorStatusConstants[0].status"
                                    class="dashboard-white-box"
                                >
                                    {{factor.repeat}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>
<app-footer></app-footer>
